import { render, staticRenderFns } from "./BrickCircleBase.vue?vue&type=template&id=291d43ec&scoped=true&"
import script from "./BrickCircleBase.vue?vue&type=script&lang=js&"
export * from "./BrickCircleBase.vue?vue&type=script&lang=js&"
import style0 from "./BrickCircleBase.vue?vue&type=style&index=0&id=291d43ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d43ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291d43ec')) {
      api.createRecord('291d43ec', component.options)
    } else {
      api.reload('291d43ec', component.options)
    }
    module.hot.accept("./BrickCircleBase.vue?vue&type=template&id=291d43ec&scoped=true&", function () {
      api.rerender('291d43ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Patterns/BrickCircleBase.vue"
export default component.exports